let role = ''

export const roleHandler = value => {
  if (!value) return role
  role = value
}
